<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <form @submit.prevent="passes(goToNextPage)">
      <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
        Step 3: Company Information
      </h2>
      <d-field :rules="{required: { allowFalse: false }}" name="Field">
        <d-checkbox v-model="conductsWithGeneralPublic">
          This company actively seeks and conducts business with the general public (Policy Requirement)
        </d-checkbox>
      </d-field>
      <d-field label="Years In Business">
        <d-input v-model="yearsInBusiness" aria-label="number of years in business" min="0" type="number" required />
      </d-field>
      <d-field label="# of Employees">
        <d-input v-model="numberOfEmployees" aria-label="number of employees" min="0" type="number" required />
      </d-field>
      <d-field label="# Employees in Office">
        <d-input v-model="numberOfEmployeesInOffice" aria-label="number of employees in office" min="0" type="number" required />
      </d-field>
      <d-field label="# Installers">
        <d-input v-model="numberInstallers" aria-label="number of installers" min="0" type="number" required />
      </d-field>
      <d-field label="Total Sq. Footage">
        <d-input v-model="totalSquareFootage" aria-label="total sq footage" min="0" type="number" required />
      </d-field>
      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="Own or Lease Facility" class="w-full md:w-1/2 px-5">
          <d-select v-model="ownLeaseFacility" required expanded>
            <option value="own">
              Own
            </option>
            <option value="lease">
              Lease
            </option>
          </d-select>
        </d-field>
        <d-field label="Own or Lease Equipment" class="w-full md:w-1/2 px-5">
          <d-select v-model="ownLeaseEquipment" required expanded>
            <option value="own">
              Own
            </option>
            <option value="lease">
              Lease
            </option>
          </d-select>
        </d-field>
      </div>
      <d-field label="Annual Gross Sales">
        <d-input v-model="annualGrossSales" aria-label="annual gross sales" min="0" type="number" required />
      </d-field>
      <d-field label="Line of Business">
        <div>
          <div>
            <d-checkbox v-model="lineOfBusiness" native-value="Fabrication">
              Fabrication
            </d-checkbox>
          </div>
          <div>
            <d-checkbox v-model="lineOfBusiness" native-value="Finishing">
              Finishing
            </d-checkbox>
          </div>
          <div>
            <d-checkbox v-model="lineOfBusiness" native-value="Installation">
              Installation
            </d-checkbox>
          </div>
        </div>
      </d-field>
      <d-field label="Business Summary">
        <d-input v-model="businessSummary" aria-label="business summary" type="textarea" required placeholder="Briefly describe your company's Architectural Woodwork business including operations, specialty (if any), and customer base" />
      </d-field>
      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '../../../../Resources/scripts/utilities/field.utilities';
  import { APPLY_FOR_LICENSING_FORM } from '../../../../Resources/scripts/store/mutation-types';

  const { mapActions } = createNamespacedHelpers('applyForLicensing');

  export default {
    parent: true,

    computed: {
      ...mapFields({
        fields: ['conductsWithGeneralPublic', 'yearsInBusiness', 'numberOfEmployees', 'numberOfEmployeesInOffice', 'numberInstallers', 'totalSquareFootage', 'ownLeaseFacility', 'ownLeaseEquipment', 'annualGrossSales', 'lineOfBusiness', 'businessSummary'],
        module: 'applyForLicensing',
        base: 'formFields',
        mutation: APPLY_FOR_LICENSING_FORM.FORM_FIELDS,
      }),
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'goToNextPage',
      ]),
    },
  };
</script>